import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_apex_web_insurance_dynamic_link",
  stages: {
    main: 1,
    insurance: 2,
    cnp: 3,
    pb: 4
  },
  defaultStage: 1,
  goals: {
    ipid_mismatch_offer: 1,
    ipid_mismatch_order: 2,
    dynamic_dip_danni_not_present_italy: 3,
    dip_danni_mismatch_offer_italy: 4
  }
});

export default utils;
